// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"348":"3c79d319","569":"6a7e31f5","652":"9080a1c5","787":"ff5e469e","903":"c9be4dab","919":"28f6d559"}[chunkId] + ".chunk.js";
};